/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';
import {
  Layout,
  Typography,
} from 'antd';
import './TermsAndConditions.less';
// import { Link } from 'react-router-dom';
// import Routes from '../../Global/Routes';

function TermsAndConditions() {
  return (
    <Layout.Content className="terms_bg">
      <div>
        <Typography.Title level={1} className="text-white text-center">Terms and Conditions</Typography.Title>
        <div className="px-3 px-sm-5">
          <Typography.Title level={4} className="text-white text-left">1. Introduction</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            These terms govern the use of KUD’s website and services, including job applications, portfolio access, and newsletter subscriptions.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">2. Intellectual Property</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            All content on the site, including downloadable portfolios, remains the intellectual property of KUD. Users are prohibited from reproducing or redistributing this content without permission.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">3. User Responsibilities</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            Users agree to provide accurate information and refrain from engaging in unlawful or unauthorized activities on the website. Unauthorized access or attempts to bypass security protocols are strictly prohibited.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">4. Limitation of Liability</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            KUD is not liable for damages arising from the website’s use, including data loss, breaches, or technical issues, except as mandated by Kuwaiti law.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">5. Data Usage Consent</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            By using the site, users consent to data collection as described in the Privacy Policy, including cookies for analytics purposes. Explicit consent is required for accessing secure areas, such as the portfolio request feature.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">6. Governing Law</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            These terms are governed by Kuwaiti law, and disputes arising from these terms shall be resolved under Kuwaiti jurisdiction.
          </Typography.Paragraph>

          <Typography.Title level={4} className="text-white text-left">7. Modification of Terms</Typography.Title>
          <Typography.Paragraph className="off-white fs-16">
            KUD reserves the right to modify these terms and will inform users of significant updates.
          </Typography.Paragraph>
        </div>
        {/* <Link to={Routes.home} className="d-table m-auto">
          <div className="border-0 border-radius primary r-bold h-40 bg-white d-flex justify-content-center align-items-center px-5">Home</div>
        </Link> */}
      </div>
    </Layout.Content>
  );
}

export default TermsAndConditions;
